import { Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { imageUrl } from '../../util';
import './CardModal.css';

function CardModal({ children, card }) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(!show);
    const handleShow = () => setShow(true);

    let pbImage = imageUrl(card?.imageStub);

    return <>
        < div onClick={handleShow} >
            {children}
        </div >
        <Modal show={show} onHide={handleClose}
            dialogClassName="modal-90w"
        >
            <Modal.Body onClick={handleClose} className='trimmed-modal'>
                <img className='img-fluid' src={pbImage} />
            </Modal.Body>
        </Modal>
    </>
}

export default CardModal;
